import { ShapeOptions } from '@mui/system';

const shape: ShapeOptions = {
  borderRadius: 4,
};

export default shape;
